import React from 'react'
import Task from '../../components/Task/Task'

function TaskPage() {
  return (
    <Task />
  )
}

export default TaskPage